export const locale = {
  lang: 'mx',
  data: {
    TESTLANG: 'mx_base',
    LNG_TIENDAS: 'Tiendas',
    LNG_TIENDA: 'Tienda',
    GENERIC_ERRORS: {},
    LINEAR_SPACE_TYPES: {},
    LNG_PRODUCTS_TYPES: {},
    LNG_STORES_TYPES: {
      StoreAndDistributionCenter: 'CEDIS',
    },
    LNG_STRATEGIES_VARIABLES: {},
    LNG_STRATEGIES_EVENTS: {},
    STATUS_CONNECTION: {},
    ABM_STATUS: {},
    PUBLISH_STATUS: {},
    TIME_UNITS_SHORT: {},
    GLOBAL: {},
    TYPE_ACTION: {
      TOOLTIP: {},
    },
    NOTIFICATIONS: {},
    INSIGHTS: {},
    GLOBAL_CONFIG: {},
    HELPS: {
      PRICE: {
        FAQS: {},
      },
    },
    GENERIC_COMP: {
      SCOPE: {
        ITEM_LIST_WITH_ACTIONS: {
          TABLE: {
            MODAL: {},
          },
        },
        TAG_SELECTOR: 'Selección de Atributos',
        ADVANCED_TAG_SELECTOR: '(Selección Avanzada de Atributos)',
      },
      LOOKUP: {},
      CAT_SELECT_V2: {},
      WEEKDAY_COMPONENT_DAYS: {},
      IMPORTERV2: {
        AssortmentMarketData_alternativeDescription:
          'Una vez finalizada la importación, es necesario asignar los nuevos productos de mercado a una categoría de Prisma desde la siguiente pantalla: <br><b>Variedad > Configuración > Productos de Mercado</b>',
        TITLES: {
          STORE_ASSORTMENT: 'Variedad por Punto de Venta',
          StoreAssortment: 'Variedad en Tiendas',
          MaterialTagValue: 'Material promocional por atributo',
        },
        TYPES: {
          AssortmentOutputPreview: 'Publicación de Variedad - Preview',
          AssortmentOutput: 'Publicación de Variedad',
          StoreAssortment: 'Variedad en Tiendas',
          ItemTags: 'Atributos de artículos',
          StoreTags: 'Atributos de tiendas',
          TagValues: 'Valores de atributos',
          MaterialTagValue: 'Material promocional por atributo',
        },
        STATUS: {},
        STATUS_MSG: {},
        SOURCE: {},
      },
      INTERFACES_LOG: {},
    },
    PRICE_RULES: {
      COMPETENCE: {
        POSITION_AGAINST: {},
        POSITION_TREND: {},
        RULE_TYPE: {},
      },
    },
    NAV: {
      HOME: {},
      DASHBOARD: {},
      DATA_ENTRY_ADAPTATIONS: {},
      PRICES: {
        SETUP: {},
        DECISIONS: {},
        REPORTS: {
          CONTEXT_REPORT: 'Reporte de Competitividad',
        },
        ADMIN: {
          TAXES: {},
          IMPORTERS: {},
        },
      },
      ADMIN: {
        MASTER: {
          TAG: 'Atributo',
          TAGS: 'Atributos',
        },
        SECURITY: {},
      },
      MYSTERYSHOPPER: {
        TITLE: 'Competitividad',
        MISSIONS: {
          TITLE: 'Tareas',
        },
        USER_ASSIGNMENT: {},
      },
      ITEMMASTER: {
        TITLE: 'Catálogo',
      },
      ASSORTMENT: {
        TITLE: 'Variedad',
        SETUP: {},
        DECISIONS: {
          ASSORTMENTASIGNATION: 'Decisiones de Variedad',
          DINAMIC_COLUMNS_GROUP: {},
          DINAMIC_COLUMNS: {
            tag: 'Atributos',
          },
          TAGS_IN_USE: 'Solo es posible gestionar atributos que se encuentren aplicadas a los productos de este cluster',
        },
        REPORTS: {},
        ADMINISTRATION: {
          IMPORTERS: {},
        },
      },
      PROMOTIONS: {
        CAMPAIGN: {},
        ACTIONS: {},
      },
      PROMOTIONSV2: {
        CONFIGURATIONS: {
          RULES: {},
          REFERENCE_PRICES: {},
          PROMOTIONAL_PROCESS: {},
          MESSAGE_STRUCTURES: {},
        },
        CAMPAIGN: {},
        CALENDAR: {},
        PERIODS: {},
        PROMOTIONAL_PERIOD: {},
        ACTIONS: {},
        PRODUCTIONLIST: {},
        PRODUCTION_REPORTS: {},
        PROMOTION_OUTPUT: {},
        LOGISTICS_REPORT: {},
        AVAILABLE_SPACES: {},
        PROMOTION_REPORT: {},
        PROMOTION_PRODUCTION_LISTS: {},
        MARKETPLACE: {},
        REPORTS: {},
      },
      SPACES: {
        INCONSISTENCIES: {},
        FLOORPLANS: {},
        SPACES_TEMPLATES: {
          TITLE: 'Estrategias',
        },
        PLANOGRAMS: {},
        STRUCTURE: {
          TITLE: 'Mueble',
        },
        GENERIC_SPACE: {},
        SUPER_PLANOS: {},
        POPMATERIAL: {},
      },
      REPORTS: {
        LIST: {},
      },
      SUPPLY: {
        SETUP: {},
        DECISIONS: {},
        ADMINISTRATION: {},
      },
    },
    TEST_COMPONENT: {
      ANIDADA: {},
      TEST_J_ENUM: {},
    },
    DATA_ENTRY_ADAPTATIONS: {
      TABLE: {},
      EDIT: {
        TRANSFORMATION_TYPES: {},
      },
      COMP: {
        FILE_UPLOAD: {},
      },
    },
    HOME: {
      ASSORTMENT_MODULE: 'Variedad',
      ASSORTMENT_MODULE_ROL: 'Variedad - Roles',
      ASSORTMENT_MODULE_STRATEGIES: 'Variedad - Estrategias',
      ASSORTMENT_MODULE_DECISIONS: 'Variedad - Decisiones',
      ITEM_MASTER_MODULE: 'Catálogo',
    },
    PR: {
      STP: {
        COMP: {
          LIST: {},
        },
        SENSITIVITIES: {
          _weekday: {},
          _frecuency: {},
        },
        ROUND: {},
        RULES: {
          DELETE_MODAL: {},
        },
        BRAND: {},
        GUI_AND_STRA: {
          ASSORTMENTV2: {
            DECISIONS: {
              SUMMARY_TABLE: {
                INCLUDE_NEW_ITEMS: 'Incluir nuevos',
                INCLUDE_NEW_ITEMS_LABEL: 'Incluir ',
                INCLUDE_NEW_ITEMS_BADGE: 'Nuevos',
                ITEM_NEW: 'Nuevo',
                CLUSTERS_LABEL: 'Clusters',
                CLUSTERS_TOTAL_GENERAL: 'Total General',
                CLUSTERS_ADD_LABEL: 'Agregar Etiqueta',
                CLUSTERS_APPLY: 'Aplicar',
                CLUSTERS_SEARCH: 'Buscar...',
                CLUSTERS_NO_TAGS: 'Sin etiquetas disponibles',
                CLUSTERS_NO_VALUES: 'Sin resultados',
                CLUSTERS_SELECT_VALUES: 'Seleccionar valores',
                CLUSTERS_REMOVE: 'Eliminar',
                CLUSTERS_VISIBLE: 'clusters a visualizar',
                CLUSTERS_VISIBLE_PANEL_TITLE: 'Clusters a visualizar',
                CLUSTERS_MAX_REACHED: 'Límite de 20 clusters alcanzado. Deselecciona uno para agregar otro.',
                ADD_MULTI_VARIABLE_ANALYSIS: 'Agregar análisis multivariable',
              },
            },
          },
        },
      },
      REPORTS: {
        SUGGESTIONREPORTS: {},
        COSTREPORTS: {},
        YPF: {},
        DAILYMARGIN: {
          LIST: {},
        },
        PRICE_INCONSISTENCY: {
          STORE: 'Tienda',
        },
        PRICES_MAP: {},
        COMPETITOR_PRICES: {},
        PRICES_AUDIT: {},
        PRICE_REPORT: {},
        CONTEXT_REPORT: {
          TITLE: 'Reporte de Competitividad',
          SUBTITLE: 'Reporte de Competitividad',
          HEADER: {
            SAVE_OBSERVATIONS: 'Aplicado desde Reporte de Competitividad',
          },
        },
      },
      DECISIONS: {
        SUMMARY: {},
        ERP: {},
        PRICE_DECISIONS: {
          STRATEGY_DIALOG: {},
          RULE_TYPE: {},
          ADVANCED_FILTER: {},
          TAB: {},
          WARNINGS_PRICES_LIST: {},
        },
      },
      TAXES: {
        IIBB: {},
        CO2: {},
        ICL: {},
      },
      IMPORTERS: {
        PARITY: {},
        FERRYES_AND_COMISIONS: {},
        COST_AND_TAXES: {},
        VENDOR_COST: {},
        STORE_TAXES: {},
        NEW_PRICES: {},
        COMPETITOR_PRICES: {},
      },
    },
    ASSORT: {
      STP: {
        CLUSTERING: {},
        CLUSTER_ASSIGN: {},
        CATEGORY_SETUP: {
          LIST: {},
        },
        ROLES_STRATEGIES_ASSIGN: {},
        ROLES: {
          AUXS: {
            _variableSource: {},
            _variableSource_phrase: {},
            _variable: {},
            _variable_phrase: {},
            _method: {},
            _methodTop: {},
            _method_phrase: {},
            _condition: {},
            _condition_phrase: {},
            _conditionTopBottom: {},
            _conditionTopBottom_phrase: {},
            _combinationMethod: {},
            _combinationMethod_phrase: {},
            _weekday: {},
            _frecuency: {},
            _frecuency_phrase: {},
          },
        },
        STRATEGIES: {},
        SEG_ASSIGNMENT: {},
        CATEGORIES: {},
        HELP: {},
        MARKET_INFO: {
          itemMarketDataType: {},
        },
      },
      DECISIONS: {
        ASSORT_ASSIGNATION: {},
        ASSORT_ASSIGNATION_ITEM: {},
        ASSORT_CLUSTER_REPORTS: {},
        ERP: {
          REPORT_ASSORTMENT_DECISIONS: 'Decisiones de Variedad',
        },
      },
      REPORTS: {
        CLUSTER_ANALYSIS: {},
      },
      ADMIN: {
        IMPORTERS: {
          MARKET_INFO: {},
        },
      },
      ABM_MODAL: {
        ROLES_TYPES_TITLES: {},
        ROLES_TYPES_DESCRIPTION: {},
      },
    },
    IMV2: {
      LIST: {
        REPORT_REQUIRES_FILTER: 'Aplica al menos un filtro para generar el reporte',
        DEPARTMENT: 'Departamento',
        CREATOR: 'Creador',
        ENTITIES: {
          IMPEDIMENT: {},
        },
        ACTION_FAIL: {},
        ASSORTMENTBEHAVIORS: 'Variedad',
        INTERNAL_CODE: 'SKU',
      },
      EDIT: {
        AUTOSAVE: {
          SYNCING: 'Guardando automáticamente…',
          SAVED: 'Guardado automáticamente',
          ERROR: 'No se pudo guardar automáticamente',
        },
        ITEM: {
          ASSORTMENT_TAB: 'Variedad',
          CODES_TAB: 'Código de barras',
        },
        MAIN_DATA: {
          INTERNAL_CODE: 'SKU',
        },
        UNITS_OF_MEASURE: {
          CONVERSION: 'Norma de Empaque',
          FRONT_LOAD: 'Frentes',
          DEPTH_LOAD: 'Fondo',
          SRP: 'Caja',
          HEIGHT_LOAD: 'Niveles',
        },
        RECIPE: {},
        COMBO: {},
        CODES: {},
        MATCHINGS: {},
        ASSORTMENT: {
          NOT_PARAMETERIZED: 'Para habilitar este botón se debe completar la parametrización de la categoría en Variedad.',
          IMPORT_FILE_NAME_BTN: 'Carga de variedad excepcional',
          IMPORT_ASSORTMENT_STORE_CONTEXT:
            'Podrá cargar excepciones de variedad por medio del importador o consultar el estado de surtido referente a este producto',
          BTN1_TITLE: 'Basado en la variedad',
          BTN4_TITLE: 'Sólo variedad de Pts. de Venta',
          BTN3_TOOLTIP_COMBO: 'Los combos no pueden ser parte de recetas o combos',
          NO_PERMISSION_TOOLTIP: 'No tienes permisos para editar el comportamiento de variedad',
          LOCKED_BY_DELIVERY_PLACES: 'Definido por configuración de Lugares de Entrega',
          NO_IMPORT_PERMISSION_TOOLTIP: 'No tienes permisos para importar excepciones de variedad',
          BTN3_TITLE_RECIPE: 'Solo si es parte de un Combo',
          BTN3_MSG_RECIPE: 'El producto puede participar de un combo.',
          BTN1_TOOLTIP_RECIPE: 'Las recetas no pueden usar la opción Basado en Variedad cuando el módulo está licenciado',
          ASSORTMENT_SEGMENT_SETUP_CONTENT_2: 'Este cambio impactará en la pantalla de asignación de segmentos en el módulo de Variedad.',
          ASSORTMENTBEHAVIORS_BASEDONASSORTMENT: 'Basado en variedad',
          ASSORTMENTBEHAVIORS_ONLYSTOREASSORTMENT: 'Sólo variedad de Pts. de Venta',
          INIT_ASSORMENT: 'Configuración de Variedad',
          CHOOSE_OPT_ASSORMENT: 'Elegir comportamiento de variedad',
          CLONE_EXCEPTION_STORE_ASSORTMENT: 'Clonar Excepciones de Variedad',
          CLONE_EXCEPTION_STORE_ASSORTMENT_MSG:
            'Al habilitar esta opción se clonaran las excepciones de variedad de este registro. Al menos debe existir una excepción de variedad que no esté bloqueada para la venta',
          VIEW_ASSORTMENT_STATUS: 'Reporte de Variedad',
          VIEW_ASSORTMENT_STATUS_ACTUAL: 'Reporte de Variedad Actual',
          REQUIRE_SAVE_ASSORTMENT_STATUS_MSG:
            'Se detectaron cambios que afectan al estado del Variedad, para poder acceder debe guardar los cambios realizados',
          IMPORT_ITEMS: 'Variedad por punto de venta',
          IMPORT_EXCEL_ITEMS_WARNING:
            'Para poder importar excepciones de variedad y consultar el estado del mismo, es necesario al menos tener los datos principales guardados. ',
          CATEGORY_CONFIG_WARNING:
            'Para utilizar comportamiento basado en variedad, se requiere que la categoría de este ítem tenga asignadas Segmentación y Clusterización.',
          CATEGORY_WARNING:
            'La categoría {{val}} no tiene una segmentación principal definida, elija una opción para poder avanzar con la inicialización de variedad.',
          CATEGORY_SELECT_WARNING:
            'Se necesita seleccionar una categoría en este producto para poder avanzar con la inicialización de variedad.',
          CONFIG_TAG: 'Asignar valores a los atributos',
        },
        PRICES: {
          BTN1_TITLE: 'Precio Inicial',
        },
        VENDORS: {
          TAX_PERCENT_OUT_OF_RANGE: 'El valor debe estar entre 0 y 100.',
        },
      },
    },
    ITEM_MASTER: {
      DELIVERY_PLACES: {
        NO_MATCHES: 'No hay resultados para tu búsqueda.',
        NO_ROWS: 'No hay datos para mostrar.',
        DISCARD_TITLE: 'Descartar cambios',
        DISCARD_MESSAGE: 'Tienes {{count}} cambio(s) sin guardar. Si cierras el popup, se pierden. ¿Quieres cerrar de todos modos?',
        SAVE_OK_WITH_WARNINGS: 'Los cambios se guardaron, pero hay {{count}} fila(s) con advertencias. Revisa las marcadas en rojo.',
        SAVE_IMPACT_TITLE_CREATE: 'Confirmar carga de lugares de entrega',
        SAVE_IMPACT_MESSAGE_CREATE:
          'Estás cargando los lugares de entrega de este proveedor. Una vez guardado, el producto empezará a llegar a las tiendas que seleccionaste. ¿Confirmas?',
        SAVE_IMPACT_TITLE_MODIFY: 'Confirmar modificación de lugares de entrega',
        SAVE_IMPACT_MESSAGE_MODIFY:
          'Estás modificando los lugares de entrega de este proveedor: algunas tiendas van a dejar de recibir el producto por acá y otras van a empezar. ¿Confirmas?',
        CHIP_MANAGE: 'Gestionar',
        TAB_LABEL: 'Lugares de entrega',
        SAVE_VENDOR_FIRST: 'Guarda el proveedor antes de configurar los lugares de entrega',
        VENDOR_LABEL: 'Proveedor',
        PILLS_LABEL: 'Modos de entrega',
        PILL_DIRECTA: 'Directa',
        PILL_CEDIS: 'CEDIS',
        COL_REGIONS: 'Regiones',
        COL_ZONAS: 'Zonas',
        COL_TIENDAS: 'Tiendas',
        COL_CEDIS: 'CEDIS',
        SEARCH_REGION: 'Buscar región...',
        SEARCH_ZONA: 'Buscar zona...',
        SEARCH_TIENDA: 'Buscar tienda...',
        SEARCH_CEDIS: 'Buscar CEDIS...',
        TIENDAS_LABEL: 'tiendas',
        SELECT_ALL_TOOLTIP: 'Seleccionar / deseleccionar todos',
        COVERAGE_TITLE: 'Configurar cobertura del CEDIS',
        COVERAGE_HINT_APPLY_THEN_SAVE: 'Estos cambios se aplican localmente. Presiona "Guardar" en el popup principal para persistir.',
        COVERAGE_EMPTY: 'No hay tiendas que coincidan con la búsqueda.',
        COVERAGE_CONFIGURE_TOOLTIP: 'Configurar tiendas incluidas en la cobertura del CEDIS',
        COVERAGE_APPLIED_REMEMBER_SAVE: 'Cobertura aplicada. Presiona "Guardar" para confirmar los cambios.',
        APPLY_BTN: 'Aplicar',
        SAVE_BTN: 'Guardar',
        CANCEL_BTN: 'Cancelar',
        SAVING_BTN: 'Guardando...',
        SAVE_OK: 'Lugares de Entrega guardados',
        SAVE_ERROR: 'Error al guardar. Reintenta.',
        NO_CHANGES: 'No hay cambios para guardar',
        LOAD_ERROR: 'No se pudieron cargar los datos',
        COHERENCE_ERROR:
          'Conflicto de coherencia en {{count}} fila(s). Revisa las marcadas en rojo: el Tipo de Entrega debe coincidir con el resto de los proveedores para la misma tienda.',
        NO_VENDOR: 'Selecciona un proveedor para empezar.',
        NO_PILLS_ACTIVE: 'Activa al menos un modo de entrega (DIRECTA o CEDIS).',
        SAVE_IMPACT_TITLE: 'Confirmar guardado',
        SAVE_IMPACT_MESSAGE:
          'Esta operación puede modificar lugares de entrega de otros proveedores de este artículo, alineándolos al Tipo de Entrega que estás guardando. ¿Confirmas?',
      },
    },
    SUPPLY: {
      SETUP: {
        ORDER_SCHEDULE: {
          FORM: {
            SCOPE_PDV: {},
            FRECUENCY: {},
          },
          TYPEOFDELIVER: {},
          FREQUENCYTIME: {},
          HOLIDAYSHANDLING: {},
        },
        ORDER_SCHEDULE_LIST: {},
      },
      DECISIONS: {
        ORDER_CONTROL: {},
      },
    },
    ADMIN: {
      MASTER: {
        STORES: {
          LIST: {
            NEW_STORE_BTN: 'Nueva Tienda',
            STORE_TAGS: 'Atributos de Punto de Venta',
          },
          SAVE_TOOLTIP: {},
          PRICES: {},
          NEW_STORE_BTN: 'Nueva Tienda',
          ASSORTMENT_TAB: 'Variedad',
          ASSORTMENT_TITLE: 'Inicialización de Variedad',
          TABS: {
            VENDORS: {
              COMP: {},
            },
          },
        },
        STORESV2: {
          LIST: {
            NEW_STORE_BTN: 'Nueva Tienda',
            STORE_TAGS: 'Atributos de Punto de Venta',
          },
          SAVE_TOOLTIP: {},
          PRICES: {},
          CLONE_DELIVERY_PLACES: {
            TITLE: 'Clonar Lugares de Entrega desde…',
            HINT: 'Copia los Lugares de Entrega de otra tienda o CEDIS ya publicado. Reemplaza los mapeos previos del destino.',
            REQUIRES_CEDIS: 'Asigna primero un Centro de Distribución en la pestaña Datos.',
            SOURCE_NOT_ELIGIBLE: 'El origen elegido ya no es elegible (cambió el CEDIS o el estado).',
            STORE_MISSING_FOR_PUBLISH: 'La tienda no tiene Lugares de Entrega. Configúralos antes de publicar.',
            NO_SOURCES: 'No hay tiendas publicadas para clonar con este CEDIS asignado.',
          },
          EQUIPMENT: {
            OWNER_OPTION: {},
          },
          INFO_ASSORTMENT_STATUS:
            'El estado de variedad visualizado representa el estado una vez sea publicado, de igual modo todos los datos afectados por esta cambio surtirán efecto al encontrarse en ese estado.',
          IMPORT_ASSORTMENT_STORE_CONTEXT:
            'Podrá cargar excepciones de variedad por medio del importador o consultar el estado de variedad referente a este punto de venta',
          NEW_STORE_BTN: 'Nueva Tienda',
          ASSORTMENT_TAB: 'Variedad',
          ASSORTMENT_TITLE: 'Inicialización de Variedad',
          VIEW_ASSORTMENT_STATUS: 'Reporte de Variedad',
          VIEW_ASSORTMENT_STATUS_ACTUAL: 'Reporte de Variedad Actual',
          REQUIRE_SAVE_ASSORTMENT_STATUS_MSG:
            'Se detectaron cambios que afectan al estado del Variedad, para poder acceder debe guardar los cambios realizados',
          TABS: {
            VENDORS: {
              COMP: {},
            },
          },
          ITEM: {},
          COMPETITOR_SELECTED_CONTENT: 'Busque y agregue competidores por trade area y atributos',
        },
        SUPPLIER: {},
        SUPPLIERV2: {
          ITEM_FORM: {},
        },
        INSIGHTS: {},
        EQUIPMENTS: {
          TYPES: {},
        },
        DYNAMIC_ENTITIES: {
          TYPES: {},
          TAGNAME: 'Nombre de atributo',
        },
        TAGS: {
          TYPES: {},
          DATA_TYPES: {
            FreeNumber: 'Número libre',
          },
          ENTITIES: {
            ASSORTMENTASSIGNMENTS: 'Asignación de variedad: {{val}}',
            ASSORTMENTITEMEXCEPTIONS: 'Excepción de variedad por productos: {{val}}',
            ASSORTMENTSTOREEXCEPTIONS: 'Excepción de variedad por puntos de venta: {{val}}',
            ASSORTMENTCATEGORIES: 'Categorías de variedad: {{val}}',
          },
          FREE_NUMBER_VALUES_INFO:
            'Esta etiqueta es de tipo Número libre. Sus valores no se administran desde esta pantalla: se cargan en Item Master y se crean automáticamente al guardar el producto.',
          ALLOW_DIRECT_VALUE_LOAD: 'Carga directa de valores',
          ALLOW_DIRECT_VALUE_LOAD_POPOVER_TOOLTIP:
            'Permite crear valores nuevos desde la pestaña de Clasificación (Item Master, Tiendas o Proveedor) sin ir al maestro de etiquetas.',
          ADD_TAG_VALUE_INLINE: '+ Agregar valor',
          ADD_TAG_VALUE_INLINE_TITLE: 'Agregar valor de etiqueta',
          ADD_TAG_VALUE_INLINE_VALUE_LABEL: 'Valor',
          ADD_TAG_VALUE_INLINE_CONFIRM: 'Agregar',
          ADD_TAG_VALUE_INLINE_SUCCESS: 'Valor agregado',
          ADD_TAG_VALUE_INLINE_DEDUPE: 'Ese valor ya existía; se seleccionó el existente.',
          ADD_TAG_VALUE_INLINE_ERROR: 'No se pudo agregar el valor. Intentá de nuevo.',
          NEW_STORE_BTN: 'Nueva Tienda',
          TAG_IN_USE: 'No es posible eliminar un atributo que está en uso.',
          ENTITIES_IN_USE: 'Debe reasignar la siguiente cantidad de registros por cada entidad que utilizan el atributo a eliminar',
          NEW_TAG_VALUE_ADD_BTN: 'Crear nuevo valor de atributo',
          ISDELETED_POPOVER_TOOLTIP: 'Al habilitar solo se mostraran atributos eliminados',
          USEFORREPORTS_POPOVER_TOOLTIP: 'Al habilitar sólo se mostrarán los atributos asignadas para reportes',
          TERMINATION_SLIDE_POPOVER_TOOLTIP:
            'Puedes agregarle una terminación por default a los valores del atributo. Ej: para Contenido Neto, "cc" o "cm3". Etiqueta: 250 cc',
          DEPENDENCIES_POPOVER_TOOLTIP:
            'Utilizalo en el caso de que este atributo dependa de otra. Relación padre/hijo. Ej: "Ciudad" depende de "Estado"',
          SELECT_PARENT_TAG_POPOVER_TOOLTIP:
            'En caso de cambiar por otro atributo padre los valores de este atributo serán eliminados. En caso de desasignarla los valores de este atributo perderán relación con valores padres',
          SELECT_PARENT_TAG_WARNING:
            'Asegúrese de seleccionar el atributo padre correcto antes de cargar los valores padres, de cambiarse perderá los valores agregados',
          TITLE: 'Atributos',
          DELETE_TTIP: 'Borrar atributos seleccionados',
          QUANTITY_TAGS: '# Atributos',
          QUANTITY_TAGS_TTIP: 'Cantidad de atributos que pertenecen a un grupo',
          DEFINE_TAG_STP1: 'Definir atributo',
          ADMIN_TAG_STP2: 'Administrar atributo',
          EDIT_TAG: 'Editar atributo',
          DELETE_ROW: 'Eliminar atributo',
          NEW_TAG: 'Nuevo atributo',
          STP1: 'Definir atributo',
          TYPE_INPUT: 'Tipo de atributo',
          DEPENDENCIES_INPUT: 'Seleccionar atributo Padre',
          REQUIRED_WARNING_OFF_CONTENT: 'Si existe un valor de este atributo como valor por defecto, este será desactivado',
          REQUIRED_WARNING_OFF_TITLE: 'Desea que este atributo no sea obligatoria?',
          STP2: 'Administrar Valores del atributo',
          NEW_TAG_INPUT: 'Añadir nuevo atributo',
          DEPENCENCY_TAG_INPUT: 'Seleccionar valor de atributo Padre',
          TAG_VALUE_EXIST: 'Valor de atributo existente',
          DEFAULT_TTP: 'No puede asignarse valor por defecto si el atributo no es marcado como obligatorio',
          REQUIRED_DEFAULT_TAG: 'Debe configurar un valor de atributo por defecto para poder Guardar',
          TAG_UPDATE_ALL_PRODUCTS: 'Este atributo actualizará todos los Productos. ¿Desea continuar?',
          TAG_UPDATE_ALL_OWN_STORES: 'Este atributo actualizará todos los Puntos de Venta Marca Propia. ¿Desea continuar?',
          TAG_UPDATE_ALL_COMPETITORS: 'Este atributo actualizará todos los Competidores. ¿Desea continuar?',
        },
      },
      SECURITY: {
        USERS: {
          LIST: {},
          ITEM: {},
        },
        ROLES: {
          LIST: {
            TITLE: 'Roles',
            EDIT_ROW: 'Editar',
            NAME_INPUT: 'Nombre',
            DELETE_ROW: 'Eliminar',
          },
          NEW_ROLE_BTN: 'Nuevo Rol',
          DELETE: {
            TITLE: 'Eliminar Rol',
            MESSAGE: '¿Está seguro que desea eliminar el rol {{name}}? Esta acción no se puede deshacer.',
            SUCCESS_TITLE: 'Rol Eliminado',
            SUCCESS_MESSAGE: 'El rol ha sido eliminado exitosamente.',
            ERROR_TITLE: 'No se puede eliminar el rol',
            ERROR_MESSAGE: 'El rol no puede ser eliminado porque tiene usuarios asignados: {{users}}',
            GENERAL_ERROR: 'Ocurrió un error al intentar eliminar el rol. Por favor, intente nuevamente.',
          },
          ITEM: {
            ROLE: {
              assortment_decisions_view: 'Visualizar el menú de decisiones de variedad',
              assortment_output_readonly: 'Visualizar el menú de publicar decisiones de variedad y permitir generar la vista previa',
              assortment_view: 'Habilita el menú general de variedad',
              storemaster_delete: 'Acceder al menú de atributos.',
              tags_delete: 'Eliminar un atributo.',
              tags_view: 'Visualizar el menú de atributos',
              tags_save: 'Crear y actualizar atributos',
              output_context_report: 'Reporte de Competitividad',
            },
          },
        },
      },
      PROFILE: {},
    },
    PROMO: {
      CAMPAIGNS: {},
      ACTIONS: {},
      HELP: {},
    },
    PROMOV2: {
      CONFIGURATIONS: {
        LIST: {},
        FORM: {
          RULE_MESSAGES: {},
          REFERENCE_PRICE_TYPES: {},
          RULE_LIMIT_TYPES: {},
          PROMOTION_REGULAR_PRICE_CONDITION: {},
        },
        RULE_TYPES: {},
        PROMOTIONAL_PROCESS: {
          TASKS: {
            ACTIONABLES: {},
          },
        },
        MESSAGE_STRUCTURES: {
          TABS: {},
          LIST: {},
          FORM: {
            CHIP_MENU_TYPES: {
              Tags: 'Atributos',
            },
          },
        },
      },
      CAMPAIGNS_LIST: {},
      CAMPAIGNS_EDIT: {},
      ACTIONS_LIST: {
        ACTIONS: {},
        TYPE: {},
        TYPE_DEC: {},
        METHODTYPE: {},
        DISCOUNTTYPE: {},
        FREQUENCYTYPE: {},
        CLONE: {},
        CANCEL: {},
        STORE_TAGS: 'Atributos de Puntos de Ventas',
      },
      ACTIONS_TYPES: {},
      ACTIONS_EDIT: {
        MAIN_DATA: {
          TICKET_MESSAGE: {},
        },
        VALIDATIONS: {
          storesAndPromotionalSpace: {},
          MaxSlots: {},
          FixAndRegularPrice: {},
          FixPriceExceptions: {},
          Coverage: {},
          ReferencePrice: {},
          PromotionalMessage: {},
          COVERAGE_TOOLTIP:
            'Para mejorar esta validación sugerimos ajustar el alcance de tiendas o productos, previamente chequeando la cobertura por medio de atributos y analizar el estado actual de cobertura por diferentes conjuntos de puntos de venta.',
        },
        ACTIVATION: {
          ASSORTMENTMETHOD: 'Comportamiento de Variedad',
          ActionsV2_communicationType: {},
          ActionsV2_communicationDisplay: {},
          COMMUNICATION: {},
          IMPORT_LIST: {
            tagValueId: 'Atributo {{val}}',
          },
          COMBOS: {
            NAME_INPUT_VALIDATION_MESSAGES: {},
          },
          EXCEPTIONAL_FIXED_PRICE_SBUTITLE_NO_ID_ALT:
            'Podrá cargar excepciones de precios por medio del importador. Permitiendo cargar excepciones a nivel tienda o atributo (solo de puede utilizar uno de los dos nivel para todo el importador). Cada importación remplaza la importación anterior. Se requiere guardar los cambios actuales.',
          EXCEPTIONAL_DISCOUNT_SBUTITLE_ALT:
            'Podrá cargar excepciones de precios por medio del importador. Permitiendo cargar excepciones a nivel tienda o atributo (solo de puede utilizar uno de los dos nivel para todo el importador). Cada importación remplaza la importación anterior.',
          EXCEPTIONAL_FIXED_PRICE_SBUTITLE_ALT:
            'Podrá cargar excepciones de precios por medio del importador. Permitiendo cargar excepciones a nivel tienda o atributo (solo de puede utilizar uno de los dos nivel para todo el importador). Cada importación remplaza la importación anterior.',
        },
        SCOPE_ITEM: {},
        SCOPE_STORE: {},
        ActionsV2_FrequencyType: {},
        ActionsV2_AssortmentType: {},
        ActionsV2_DiscountType: {},
        PAYMENTS: {},
        GIFT_ITEMS: {},
      },
      ACTIONS_STATUS: {},
      ACTIONS_VALIDATION_STATUS: {},
      HELP: {
        ASSORTMENTMETHOD: 'Indica el comportamiento de Variedad',
      },
      PAY_METHODS: {},
      PRODUCT_LIST: {},
      PROMOTION_OUTPUT: {},
      LOGISTIC_REPORT: {},
      PROMOTION_REPORT: {},
      PROMOTION_PRODUCTION_LISTS: {},
      PROMOTION_LOG: {},
      MARKETPLACE_LIST: {},
      PERIODS_LIST: {},
      CALENDAR_LIST: {
        ACTIONS: {},
      },
      PERIODS_EDIT: {
        MAIN_DATA: {},
      },
      COVERAGE: {},
      REPORTS: {
        AVAILABLE_SPACES: {},
        TAG_VALUES: 'Descargar reporte de atributos',
      },
    },
    M_SHOPPER: {
      MISSIONS: {
        CHECK_RULE: {},
        TYPE_OPTION: {},
        FRECUENCY_OPTION: {},
        AUDYT_OPTION: {},
        METHODS_OPTION: {},
        ACTION_OPTION: {
          PriceLabelScan: 'Escaneo de etiqueta de precio',
        },
        HELP: {},
        TITLE: 'Tareas de Competitividad',
        NEW_MISSION_BTN: 'Nueva Tarea',
        NEW_TITLE_FORM: 'Nueva Tarea',
        EDIT_TITLE_FORM: 'Editar Tarea',
        TYPE: 'Tipo de Tarea',
        TYPE_INPUT: 'Tipo de Tarea',
        STATUS_ACTIVE: 'Vigentes',
        STATUS_OVERDUE: 'Vencidas',
        DEFINE_MISSION_STP1: 'Definir Tarea de Competitividad',
        STP1: 'Paso 1 - Definir Tarea de Competitividad',
        VALIDATE_RANGE_TOO_SHORT_FOR_FREQUENCY: 'El rango de fechas no cubre un ciclo completo de la frecuencia seleccionada',
        AUTOBUMP: {
          TOAST_TITLE: 'Ajustamos la fecha de finalización',
          TOAST_BODY: 'La fecha "Finaliza el" se ajustó para incluir un ciclo completo de la frecuencia seleccionada.',
        },
        ERROR: {
          MISSION_SCOPE_ITEMS_EMPTY: 'No se puede guardar la tarea: agregá al menos un ítem en el alcance.',
          MISSION_SCOPE_COMPETITORS_EMPTY: 'No se puede guardar la tarea: configurá al menos un competidor en el alcance.',
          MISSION_FREQUENCY_INVALID: 'Frecuencia inválida.',
          MISSION_RANGE_TOO_SHORT_FOR_FREQUENCY:
            'El rango de fechas no cubre un ciclo completo. Extendé "Finaliza el" como mínimo a la fecha indicada.',
        },
        EDIT_WARNING: {
          MODAL_TITLE: 'Los cambios no afectan a las tareas vigentes',
          MAIN_MESSAGE: 'Las tareas en curso (las que ya están programadas para hoy o anteriores) no se modificarán.',
          NEXT_AFFECTED_WITH_DATE: 'Los cambios aplicarán a partir de la tarea del {{date}}.',
          NEXT_AFFECTED_OVERDUE:
            'No hay tareas futuras programadas. Los cambios aplicarán cuando se generen nuevas tareas (extendiendo el rango de fechas).',
          BTN_ACCEPT: 'Aceptar',
          BTN_CANCEL: 'Cancelar',
        },
        PREVIEW: {
          STEP_TITLE: 'Resumen de Tarea',
        },
        SHOW_LAST_PRICE: 'mostrar último precio capturado.',
        SHOW_LAST_PRICE_TOOLTIP:
          'Si está activado, el usuario ve el último precio capturado del competidor para cada ítem. Desactívalo para hacer una captura sin sesgo de anclaje.',
      },
      USER_ASSIGNMENT: {
        STATUS: {},
        CLONATION: {},
        UNASSIGNED: {},
        LIST: {},
        EDIT: {
          STORE_SCOPE: {},
          COMPETITORS_SCOPE: {},
        },
      },
    },
    COMP: {
      GENERIC_TABLE: {
        COMPETITORS: {},
      },
      PRISMA_TABLE: {
        DELETE_ACTION: {},
        ENTITIES: {},
        ACTION_FAIL: {},
      },
      INSIGHT: {
        CONTEXT_MENU: {
          STORETAG: 'de la etiqueta {{val}}',
        },
      },
      MODAL: {
        IMPORT_VENDORS: {},
        ADD_MODAL_VERIFY: {},
        COPY_VENDORS_BY_STORE: {},
      },
      PICK_COLOR: {},
      KPIS: {},
      MULTIPLE_GREEN_BUTTON: {},
      ALERT_AND_CAP: {},
      DEFAULT_TBAR: {},
      ACTION_TBAR: {},
      ITEMS_NO_FOUND: {},
      ERROR_MESSAGE: {},
      DINAMIC_TAGS: {
        ELEMENTS_NOTFOUND: 'No se encontraron etiquetas',
        NO_ELEMENTS_SELECTED: 'No se seleccionaron etiquetas',
      },
      FILTER_CHARGE_COMBO: {},
      ADD_ATTRIBUTE: {},
      ERASURE_CONFIRMATION: {},
      DRAG_DROP: {},
      OPERATION_SUCCESS: {},
      IAN_IMPORTER: {},
      GEN_CATEGORYS: {},
      GEN_ITEM_LIST: {},
      GEN_ITEM_STORE: {},
      GEN_TAGS: {},
    },
    MAT_PAGINATOR: {},
    SERVICES: {
      CAN_DEACTIVATE: {},
    },
    SPACES: {
      COMMON: {},
      LIST: {
        ENTITIES: {
          IMPEDIMENT: {},
        },
        STATUS: {},
        TITLE_STRUCTURE: 'Muebles',
        BTN_STRUCTURE: 'Nueva Mueble',
        CLONE_STRUCTURE: 'Clonar solo mueble',
        CLONE_STRUCTURE_AND_PRODUCTS: 'Clonar mueble y productos',
        SURE_CLONE:
          'Está seguro que desea clonar este ítem? solo se clonara la mueble del planograma y no la configuración con todos sus productos aplicados',
        SURE_CLONE_COMPLETE:
          'Está seguro que desea clonar este ítem? se clonara la mueble del planograma y la configuración con todos sus productos aplicados',
        COLUMN: {
          STRUCTUREONLY: 'Mueble',
          STRUCTUREONLY_Structure: 'Mueble',
        },
        PLANOGRAM_TYPES: {
          Structure: 'Muebles',
        },
        PLANOGRAM_TYPE: {
          Structure: 'Mueble',
        },
      },
      TABS: {},
      GENERAL: {
        TITLE_NEW_TEMPLATE: 'Nuevo Mueble',
        TITLE_EDIT_TEMPLATE: 'Editar Mueble',
        UPDATE_STRUCTURES: 'Debe actualizarse el listado de muebles para ver los cambios realizados.',
      },
      STRUCTURE: {},
      PRODUCTS: {},
      CONFIRMATION: {},
      EXTRAS: {},
      MATERIAL_POP: {
        LIST: {},
      },
      EDITOR: {
        NEW_STRUCTURE: 'Nuevo mueble',
        MSG_CONFIRM_SAVE_TEMPLATE: '¿Confirma que desea guardar el mueble?',
        BARTAB_MODULES: 'Mueble',
        BARTAB_MODULES_PL: 'Muebles',
        TLINE_TITLE: 'Tendencia',
        TLINE_CLOSE_TL: 'Cerrar Tendencia',
        TLINE_OPEN_TL: 'Abrir Tendencia',
        TYPES: {},
        CONSTRAINS_TYPES: {},
        CLONE_STRUCTURE: 'Clonar solo mueble',
      },
      SPACES_TEMPLATES: {
        TITLE: 'Estrategias',
        TAB_STRUCTURES: 'Muebles',
        TABLE: {
          STRUCTURE_VIEW: 'Ver Mueble',
        },
        LIST: {
          TITLE: 'Listado de Estrategias',
          STRUCTURES: 'Muebles',
          TAG_SCOPE: 'Atributos Alcanzadas',
          ITEM_TAGS: 'Atributos de Producto',
        },
        PLANOGRAMS: {
          TITLE: 'Muebles Asociadas',
          INTRO: 'Asigna las muebles para vincularlas con el estrategia',
          STRUCTURES: 'Muebles',
        },
        LINEAR_SPACES: {},
        MAIN_TAB: {},
        GENERATE: {
          BTN1_TITLE: 'Generación por Mueble',
          BTN1_MSG: 'Desarrolla un planograma por cada mueble, utilizando el promedio de datos de todas las tiendas con esa mueble.',
          TEXT1:
            'Se generará un planograma por cada mueble asociada al Estrategia; la performance de cada producto será el promedio de los puntos de venta asociadas a la mueble.',
          TEXT2:
            'Se generará un planograma por cada Punto de Venta asociado a las Muebles del Estrategia; la performance de cada producto será la correspondiente a cada Punto de Venta. Importante: Si uno o más de los Puntos de Venta está presente en más de una mueble, entonces se generará un planograma por cada dupla Mueble- Punto de Venta.',
          TEXT3:
            'Se generará un planograma por cada Cluster seleccionado; la performance de cada producto será el promedio en cada Cluster. Importante: Si hay múltiples muebles, estas están a su vez asociadas Puntos de Venta de un mismo Cluster, entonces se generarán planogramas para cada dupla Cluster-Mueble.',
          SELECT_STRUCTURE: 'Muebles',
          WARNING: 'Debe guardar los cambios para generar planogramas con las nuevas modificaciones del tab muebles',
          ALERTS: {
            STRUCTURE_OVERSPACE:
              'Hay muebles con bajo índice de exhibición (sus dimensiones no satisfacen los frentes mínimos configurados), deben verificarse las dimensiones de las muebles',
          },
          CREATEVERSIONFOR_OPTIONS: {
            PerStructure: 'Muebles asociadas al Estrategia',
          },
        },
        BLOCKS: {
          SELECT_VARIABLE_OPTS: {
            Tag: 'Por atributo',
            tag: 'Atributo',
          },
          SELECT_ORIENTATION_OPTS_NEW: {},
          SELECT_CALCULATIONTYPE: {},
          SELECT_ORDERTYPE: {},
          SELECT_DIVISIONTYPE_OPTS: {},
          ALLOCATION_CRITERIA_OPTS: {},
          ORDER_OPTS: {},
          SELECT_ORIENTATION_OPTS: {},
          VALIDATIONS: {
            blockCustomSize_invalidtagValueOrCategoryId: 'Falta de categoría o atributo',
            blockCustomOrder_invalidtagValueOrCategoryId: 'Falta de categoría o atributo',
            blockCustomSize_invalidtagValueOrCategoryId_dup: 'Categoría o atributo duplicado',
            blockCustomOrder_invalidtagValueOrCategoryId_dup: 'Categoría o atributo duplicado',
            tagId_duplicate: 'Atributo duplicado',
          },
        },
      },
      FLOOR_PLANS: {
        LIST: {
          ITEM_TAGS: 'Atributos de Producto',
        },
        EDITOR: {},
      },
      SUPER_PLANOGRAMAS: {
        LIST: {},
        EDIT: {},
      },
    },
    TAGS_MODAL: {},
    REPORTS: {
      TABLE: {},
      REPORT_TYPE_KEYS: {},
      LABEL_KEYS: {},
    },
    SELLING: {
      PRICING: {},
      CTA_MODAL: {},
      ASSORTMENT: {
        TITLE: 'Variedads',
      },
      PROMOTIONS: {},
      ITEM_MASTER: {},
      SPACES: {
        FEATURE1_SUBTITLE:
          'Utiliza la función de autocompletado con días de exhibición objetivo y Prisma te va a sugerir cantidad de frentes para minimizar los quiebres de stock.',
      },
      SUPPLY: {},
    },
    GLOBAL_WARNINGS: {
      ASSORTMENT_UNCOVERED_COST:
        'Algunos puntos de venta e ítems no cubren los costos según esta decisión de variedad, puede descargar el reporte para ver el detalle.\n ¿Desea publicar de todas formas?',
    },
    INTERFACE_LOG_MSG_KEYS: {
      SameStoreAssortmentExist: 'Ya existe la variedad por punto de venta',
      WrongAssortmentBehavior: 'Comportamiento de variedad incorrecto',
      StoreAssortmentGeneratedByPromotion: 'Variedad por punto de venta generado por promoción',
      StoreAssortmentNotFound: 'No se encontró la variedad por punto de venta',
      TagValueDoesNotExists: 'El valor del atributo no existe',
      TagValueDoesNotExistsForChildTag: 'El valor del atributo no existe y el atributo depende de otro: no se puede crear desde la importación',
      TagsRequiredNotCompleted: 'Debe completar los atributos requeridos',
      TagNotFound: 'Atributo no encontrada',
      DuplicateTagValueForOneOrMoreStores: 'Valor de atributo con una o más tiendas asignadas',
      TagValueWrongType: 'El tipo de dato del valor de atributo es incorrecto',
    },
    CUSTOM_ERRORS: {
      NO_STORES_FOUND: 'No se encontraron tiendas para ejecutar esta acción.',
      SUGGESTIONS_PRE_APPROVED: 'Se preaprobaron {{val}} sugerencias.',
      SUGGESTIONS_REJECTED: 'Sugerencia rechazada',
      ItemHasNotStoreAssortment:
        'La publicación no fue llevada a cabo. Excepción por variedad se encuentra activo y no se cargó correctamente, se debe cargar en el importador al menos un producto activo y no tener bloqueo para la venta',
      PlanogramCodeFound: 'Ya existe un planograma con ese código.',
      RANGE_SERVICE_UNAVAILABLE: 'El servicio de Range no está disponible. Intentá nuevamente en unos minutos.',
      TagNameFound: 'Ya existe un atributo con el código-nombre ingresado',
      TemplateAssigned: 'No se pueden realizar acciones. El atributo relacionado está asociado.',
    },
  },
};
